import { Link } from "react-router-dom";
import { ArrowUpRight, Check } from "lucide-react";
import { Reveal } from "@/components/motion/Reveal";
import { IMAGES } from "@/data/site";

const points = [
  "Professional consultancy & compliance advisory",
  "Assessments & safety management systems",
  "Emergency preparedness & practical training",
];

export default function Intro() {
  return (
    <section className="section-pad" data-testid="intro-section">
      <div className="container-sky grid items-center gap-12 lg:grid-cols-2 lg:gap-16">
        {/* Image */}
        <Reveal className="relative order-2 lg:order-1">
          <div className="relative overflow-hidden rounded-[1.8rem] shadow-[0_24px_60px_rgba(3,56,106,0.16)]">
            <img
              src={IMAGES.consultantMeeting}
              alt="SKY safety consultants advising a corporate management team in Singapore"
              className="aspect-[4/3] w-full object-cover"
            />
          </div>
          <div className="absolute -bottom-6 -right-4 hidden rounded-2xl border border-slate-100 bg-white p-5 shadow-xl sm:block">
            <p className="font-heading text-4xl font-extrabold text-gradient-sky">2</p>
            <p className="mt-1 max-w-[9rem] text-xs font-medium leading-snug text-slate-500">
              Complementary core areas of expertise
            </p>
          </div>
        </Reveal>

        {/* Copy */}
        <div className="order-1 lg:order-2">
          <Reveal>
            <span className="tech-tag text-brand">Who We Are</span>
            <h2 className="mt-4 font-heading text-3xl font-extrabold leading-tight tracking-tight text-navy sm:text-4xl">
              Practical Safety Solutions That Go Beyond Compliance
            </h2>
            <p className="mt-6 text-base leading-relaxed text-slate-600 sm:text-lg">
              SKY is a Singapore-based professional consultancy and training company specialising in
              Workplace Safety &amp; Health and Fire Safety. We help organisations build safer, more
              compliant and better-prepared workplaces through professional consultancy, compliance
              advisory, assessments, safety management systems, emergency preparedness and practical
              training.
            </p>
            <ul className="mt-8 space-y-3.5">
              {points.map((p) => (
                <li key={p} className="flex items-start gap-3">
                  <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-brand/10 text-brand">
                    <Check className="h-3.5 w-3.5" strokeWidth={3} />
                  </span>
                  <span className="text-[15px] font-medium text-navy">{p}</span>
                </li>
              ))}
            </ul>
            <Link to="/about" className="btn-outline-sky mt-9">
              About SKY <ArrowUpRight className="h-4 w-4" />
            </Link>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
